<template>
  <div class="footer-components">
    <div class="footer-info">
      <ul>
        <template v-for="item in infoIcons">
          <li
            v-if="(item.title !== 'QQ咨询') || customer_service_QQ"
            @click="goService(item)"
            :key="item.title"
          >
            <img :src="item.src" alt />
            <p class="title">{{ item.title }}</p>
            <p class="sunTitle">{{ item.sunTitle }}</p>
          </li>
        </template>
      </ul>
    </div>
    <div class="container game-platform">
      <ul class="ensure">
        <template v-for="(item, index) in concatList">
          <li @click="goService(item)" v-if="item.detail" :key="index">
            <span class="title">{{ item.name }}:</span>
            <span class="desc">{{ item.detail }}</span>
          </li>
        </template>
      </ul>
      <div class="footer-bottomcon"></div>
    </div>
    <section class="bottom-type">
      <ul v-if="navData.length > 0" class="up-nav">
        <li
          v-for="(item, index) in navData"
          @click="goDeatil(item.id, index)"
          :class="{ noBefore: index === 0 }"
          :key="index"
        >
          {{ item.name }}
        </li>
      </ul>
      <p class="describe">{{ year }} © 9570娱乐版权所有</p>
    </section>
  </div>
</template>

<script>
/*eslint-disable*/
import { common } from "@/common/index";
import { mapState } from "vuex";

export default {
  name: "footerNav",
  data() {
    return {
      year: "",
      concatList: [
        //客服注释
        { name: "客服QQ", detail: "", url: "", href: "" },
        {
          name: "邮箱",
          detail: this.cs_Email || "9570cs@gmail.com",
          url: "",
          href: "",
        },
        {
          name: "在线客服",
          detail: this.cs_wechat || "ONLINE SERVICE",
          url: "",
          href: "#",
        },
      ],
      navData: [],
    };
  },
  watch: {
    customer_service_QQ(val) {
      this.concatList[0].detail = val;
    },
  },
  computed: {
    ...mapState({
      customer_service_QQ: (state) => state.FrontConfigList.customer_service_QQ, //路线导航，备用网址
      customerUrl: (state) => state.linkList.customerUrl,
      cs_Email: (state) => state.linkList.cs_Email,
      cs_mobile: (state) => state.linkList.cs_mobile,
      cs_qq: (state) => state.linkList.cs_qq,
      cs_wechat: (state) => state.linkList.cs_wechat,
    }),

    infoIcons() {
      let qq = this.customer_service_QQ;
      return [
        {
          src: require("./info_icon/info_chat.png"),
          title: "在线客服",
          sunTitle: "接电倾听最诚心",
          url: "",
          href: "#",
          params: {},
        },
        {
          src: require("./info_icon/info_qq.png"),
          title: "QQ咨询",
          sunTitle: "倾听 信任 承诺",
          url: "",
          href: `http://wpa.qq.com/msgrd?v=3&uin=${this.customer_service_QQ}&site=qq&menu=yes`,
          params: {},
        },
        {
          src: require("./info_icon/info_icon01.png"),
          title: "产品服务",
          sunTitle: "全球最具齐全的游戏平台",
          url: "/discounts",
          href: "",
          params: {},
        },
        {
          src: require("./info_icon/info_icon02.png"),
          title: "政府认证",
          sunTitle: "有用正规政府颁发牌照",
          url: "/helpCenter/startUse",
          href: "",
          params: { id: 38, index: 0 },
        },
        {
          src: require("./info_icon/info_icon03.png"),
          title: "高效存取款",
          sunTitle: "存取款3分钟内到账",
          url: "/helpCenter/startUse",
          href: "",
          params: { id: 41, index: 2 },
        },
      ];
    },
  },
  methods: {
    goService(item) {
      if (item.href) {
        let target = "";
        if (item.href.startsWith("#")) {
          target = this.customerUrl;
        } else {
          target = item.href;
        }
        window.open(target, "", "height=500, width=600");
      }
      if (item.url) {
        this.$router.push({ path: item.url, query: item.params });
      }
    },
    goDeatil(id, index) {
      index = index.toString();
      this.$router.push({
        path: "/helpCenter/startUse",
        query: { id: id, index: index },
      });
    },
  },
  mounted() {
    this.year = common.setCopyright();
  },
  created() {
    common.getArticleType().then((data) => {
      if (data.length > 0) {
        this.$store.commit("set_downNav", data);
        this.navData = data;
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import "../../style/variable";

.footer-components {
  text-align: center;
  padding-top: 43px;
  padding-bottom: 20px;
  border-top: 2px #2f2f2f solid;
  .game-platform {
    .footer-bottomcon {
      height: 139px;
      position: relative;
      background: url("../../assets/images/footer/foot_pic.jpg") no-repeat
        center center;
      border-bottom: 1px #434343 dotted;
      padding-bottom: 20px;
    }
    .ensure {
      border-top: solid 1px #292929;
      text-align: center;
      padding: 20px 0;
      color: #635846;
      font-size: 14px;
      li {
        cursor: pointer;
        display: inline-block;
        width: 250px;
        .title {
          color: #666;
        }
        .desc {
          color: #fff;
        }
      }
    }
  }
  .footer-info {
    padding-bottom: 20px;
    ul {
      li {
        display: inline-block;
        width: 185px;
        cursor: pointer;
        &:hover {
          .sunTitle,
          .title {
            color: #f8e978;
          }
        }
        .title {
          display: block;
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          margin-top: 10px;
        }
        .sunTitle {
          color: #666;
        }
      }
    }
  }
  .bottom-type {
    color: #ffffff;
    font-size: 14px;

    .up-nav {
      li {
        display: inline-block;
        height: 51px;
        line-height: 51px;
        cursor: pointer;
        font-size: 12px;
        &:before {
          content: "|";
          display: inline-block;
          padding: 0 6px;
          color: #323232;
          font-size: 12px;
        }
        &:hover {
          color: $font-v-hover;
        }
        .green {
          color: $font-v-green;
        }
        .gold {
          color: #e5da89;
        }
        .red {
          color: $font-v-red;
        }
      }
      .noBefore {
        &:before {
          content: "";
        }
      }
    }
    .describe {
      color: #666;
      width: 1116px;
      margin: 8px auto 0;
      line-height: 1.6;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build08/components/footer/footerNav.vue